import ComponentLayout from "../../../../src/layouts/component-layout";
import { BoxSpacingValues, BoxBackgroundColors, BoxBorderColorOptions, BoxBorderRadiusOptions, BoxBorderWidthOptions, AnimationVariants } from '@primer/react-brand';
import { Box as Container } from '@primer/react';
import { PropTableValues } from "../../../../src/components";
import * as React from 'react';
export default {
  ComponentLayout,
  BoxSpacingValues,
  BoxBackgroundColors,
  BoxBorderColorOptions,
  BoxBorderRadiusOptions,
  BoxBorderWidthOptions,
  AnimationVariants,
  Container,
  PropTableValues,
  React
};